import { getDataGridDynamicHeight } from '@modules/common/utils';
import { useFetchPermissionsForUserTypes } from '@modules/users/hooks';
import {
  getPermissionsColumns,
  getPermissionsGridInitialState,
  getPermissionsRows,
} from '@modules/users/utils';
import { useIsUserRolesEnabled } from '@modules/workspaceSettings/hooks';
import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { UserType } from 'generated/graphql';

const TABLE_HEIGHT = 500;
const ROW_HEIGHT = 38;
const HEADER_HEIGHT = 45;

export const PermissionsTable = () => {
  const isUserRolesEnabled = useIsUserRolesEnabled();

  const { data, isLoading } = useFetchPermissionsForUserTypes({
    types: isUserRolesEnabled
      ? [UserType.Manager, UserType.Editor, UserType.Member, UserType.Viewer]
      : [UserType.Manager, UserType.Editor],
  });

  const columns = getPermissionsColumns(isUserRolesEnabled);
  const rows = getPermissionsRows(data);
  const initialState = getPermissionsGridInitialState();

  return (
    <Box
      sx={{
        height: getDataGridDynamicHeight(
          TABLE_HEIGHT,
          rows.length,
          ROW_HEIGHT,
          HEADER_HEIGHT,
        ),
        width: '100%',
      }}
    >
      <DataGridPro
        sx={{
          border: 'none',
          '& .MuiDataGrid-row': {
            '&: hover': {
              background: 'transparent',
            },
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
        }}
        initialState={isUserRolesEnabled ? undefined : initialState}
        rows={rows}
        columns={columns}
        rowHeight={ROW_HEIGHT}
        columnHeaderHeight={HEADER_HEIGHT}
        hideFooter
        disableColumnMenu
        getRowId={({ module }) => module}
        loading={isLoading}
        disableRowSelectionOnClick
      />
    </Box>
  );
};
